define(function () {
  var FIELDS = ['email', 'partner_name'];

  var getInputName = function(name){
    return 'partners[invites][]['+name+']';
  };

  var getInputsData = function(container){
    var result = {};

    FIELDS.forEach(function(field_name) {
      var field = container.find('#partners-invite-' + field_name);
      result[field_name] = field.val();
    });

    return result;
  };

  var clearFields = function(fields){
    fields.find('input, textarea').val('').removeClass('dirty');
  };

  var addHtml = function(data, beforeElement){
    if(data.email && data.partner_name){
      var _template = $('.partners-invite-fields.partners-invite.dn');
      var template = _template.clone();
      template.removeClass('dn');

      FIELDS.forEach(function(field_name) {
        template.find('.view-'+field_name).html(data[field_name]);
        template.find('input[name=' + field_name + ']').attr({
          name: getInputName(field_name),
          value: data[field_name]
        });
      });
      clearFields(beforeElement);
      template.insertBefore(beforeElement);
    }
  };

  var editHtml = function(parent){
    var _template = $('.partners-invite__edit.dn');
    var template = _template.clone();

    FIELDS.forEach(function(field_name) {
      var input = parent.find("input[name='" + getInputName(field_name) + "']").val();
      template.find('.input-'+field_name).val(input)
    });
    var view = parent.find('.partners-invite__view');
    template.insertBefore(view);
    view.addClass('dn');
    template.removeClass('dn');
  };

  var applyHtml = function(parent){
    FIELDS.forEach(function(field_name) {
      var input = parent.find('.input-'+field_name).val();
      parent.find("input[name='" + getInputName(field_name) + "']").val(input);
      parent.find('.view-'+field_name).html(input);
    });
    parent.find('.partners-invite__edit').remove();
    parent.find('.partners-invite__view').removeClass('dn');
  };

  var add = function() {
    var container = $('.partners-invite-fields.partners-invite-new');
    var userInputs = getInputsData(container);
    addHtml(userInputs, container);
  };

  var edit = function(el) {
    var parent = el.parents('.partners-invite-fields');
    editHtml(parent);
  };

  var apply = function(el) {
    var parent = el.parents('.partners-invite-fields');
    applyHtml(parent);
  };

  var cancel = function(el) {
    var parent = el.parents('.partners-invite-fields');
    parent.find('.partners-invite__edit').remove();
    parent.find('.partners-invite__view').removeClass('dn');
  };

  var remove = function(el){
    el.parents('.partners-invite-fields').remove();
  };

  return {
    add: add,
    edit: edit,
    apply: apply,
    cancel: cancel,
    remove: remove,
    addHtml: addHtml
  };
});
